import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=b01d2cf2&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b01d2cf2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b01d2cf2')) {
      api.createRecord('b01d2cf2', component.options)
    } else {
      api.reload('b01d2cf2', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=b01d2cf2&scoped=true&", function () {
      api.rerender('b01d2cf2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2vb8QIjivVl6o/JS/comp/Accordion.vue"
export default component.exports